import React from 'react';

import { LazyConfigurationPage } from '@confluence/site-settings/entry-points/ConfigurationPage';
import { ADMIN_CONFIGURATION_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/configurationConstants';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminConfigurationRoute = () => <LazyConfigurationPage />;

AdminConfigurationRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_CONFIGURATION_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
